import type { CaminhoConstruido } from './sprint';

/**
 * AS TELAS DA EMPRESA INTEIRA — o que quem tem acesso a só parte da empresa
 * (uma filial, uma obra ou um contrato) não abre.
 *
 * Achado dos robôs (20/10/2026, rodada 3): o Paulo, controladoria só no
 * contrato CTR-2026-01, via "Orçamento e caixa" e "Renovação da frota" no Mais
 * do celular e no menu da mesa; ao abrir, 400 em `/orcamento/versoes` e
 * `/renovacao/frota` com "o seu acesso cobre só parte da empresa" — e o toast
 * "Não foi feito". A recusa é regra de propósito (o previsto, o caixa e a
 * frota do tipo de uma parte seriam lidos como os da empresa); o defeito era a
 * tela oferecer o que o servidor recusa e tratar a recusa como falha.
 *
 * A sessão diz o alcance (`alcanceParcial`, pela MESMA `org.filiais_do_escopo()`
 * que as rotas conferem), o menu e o Mais não oferecem estas telas, e o
 * caminho direto abre o estado próprio, com a frase do servidor e sem toast.
 *
 * As frases são cópia das do servidor (`backend/src/orcamento/premissas.ts`,
 * `FRASE_DO_ALCANCE_DO_ORCAMENTO`; `backend/src/estrategia/premissas.ts`,
 * `FRASE_DO_ALCANCE`): o teste `alcance.test.ts` reprova a cópia que divergir.
 */
export const FRASE_DO_ORCAMENTO =
  'O orçamento é da empresa inteira, e o seu acesso cobre só parte dela (uma filial, uma obra ou um contrato): '
  + 'o previsto, o realizado e o caixa de uma parte seriam lidos como os da empresa. Peça a quem administra um papel na empresa inteira.';

export const FRASE_DA_RENOVACAO =
  'A renovação compara a máquina com a frota do tipo e com o caixa da empresa inteira, e o seu acesso cobre só parte dela (uma filial, uma obra ou um contrato). '
  + 'Peça a quem administra um papel na empresa inteira.';

/** A tela da mesa da empresa inteira, e a frase que o servidor dá a quem tem só parte dela. */
export const TELAS_DA_EMPRESA_INTEIRA = {
  '/orcamento': FRASE_DO_ORCAMENTO,
  '/investimentos': FRASE_DA_RENOVACAO,
  '/equipamentos/renovacao': FRASE_DA_RENOVACAO,
} as const satisfies Partial<Record<CaminhoConstruido, string>>;

/** A frase da tela da empresa inteira, ou `null` se a tela serve a qualquer alcance. */
export function fraseDaEmpresaInteira(caminho: string): string | null {
  return (TELAS_DA_EMPRESA_INTEIRA as Readonly<Record<string, string>>)[caminho] ?? null;
}

/** A tela cabe no alcance da pessoa? A sessão em trânsito (`null`) não recorta. */
export function cabeNoAlcance(caminho: string, alcanceParcial: boolean | null | undefined): boolean {
  return alcanceParcial !== true || fraseDaEmpresaInteira(caminho) === null;
}
